import type { TraitListColDef } from '../../TraitList.model';

const accountCountColDef: TraitListColDef<number> = {
  field: 'accountCount',
  headerName: 'Accounts with Trait',
  type: 'numericColumn',
  filter: 'agNumberColumnFilter',
  initialWidth: 150,
};

export default accountCountColDef;
